import type { FinEnvironmentName, IFinEnvironment } from './environment-types';

export const environment: IFinEnvironment = {
  name: 'fnvrtdemo' as FinEnvironmentName,
  production: true,
  isSaaSProject: false,
  api: {
    gatewayWSUrl: 'wss://gateway.services.demo.ds.finverity.com/graphql',
    gatewayUrl: 'https://gateway.services.demo.ds.finverity.com/graphql',
    SSOUrl: 'https://sso.services.demo.ds.finverity.com',
    currenciesUrl: 'https://gateway.services.demo.ds.finverity.com/utils/currency-config',
    userDocumentsUrl: 'https://sso.services.demo.ds.finverity.com/document-signs',
    fileServerUrl: 'https://fileuploader.services.demo.ds.finverity.com/files',
    integrationDocumentationUrl: 'https://gateway.services.demo.ds.finverity.com/v1/api/integration-docs',
    fullAPIReferenceUrl: 'https://gateway.services.demo.ds.finverity.com/v1/api/docs',
    rateLimiterHeader: '',
    maxUserInactivityMinutes: 60,
  },
  platform: {
    title: 'Finverity Platform',
    company: 'Finverity LTD',
    displayUrl: 'Finverity.com',
    companyAddress: 'England, London E14 4AL',
    logo: {
      default: { src: 'assets/logo/logo.svg', width: 186, height: 44 },
      login: { src: 'assets/logo/logo-login.svg', width: 304, height: 72 },
      collapsedSidebar: { src: 'assets/logo/logo-sidebar-collapsed.svg', width: 44, height: 44 },
    },
    faviconUrl: 'assets/favicon/favicon.ico',
    email: 'support@finverity.com',
    helpLink: 'https://support.finverity.com/kb/guide/en/landing-page-Z0IncfcZbi/Steps/3514119',
    reportingModuleLink: 'https://reporting.demo.ds.finverity.com/',
    isSsoAuthEnabled: false,
    locale: 'en-GB',
    showHandEmojiInDashboard: true,
  },
  sentry: {
    enabled: true,
    dsn: 'https://aea0ee4f0b1b49f6b18d5d15aeda5420@o4504480764723200.ingest.sentry.io/4504519285538816',
  },
  firebase: {
    appName: 'FINVERITY',
    apiKey: 'AIzaSyAP2IlVBE8E3ItzeX6e9FkH0GH2mT9GClc',
    authDomain: 'finverity-staging.firebaseapp.com',
    databaseURL: 'https://finverity-staging.firebaseio.com',
    projectId: 'finverity-staging',
    storageBucket: 'finverity-staging.appspot.com',
    messagingSenderId: '1037880577124',
    appId: '1:1037880577124:web:3dd9469e015bef2ffe2371',
    measurementId: 'G-M90YF15270',
  },
  stonly: {
    enabled: true,
    widgetId: '848e9ac1-cbfc-11ee-bc11-06cb0cb2a85e',
  },
  userSnap: {
    enabled: true,
    GlobalAPIKey: '8d1ac1d2-2145-492b-9ad8-62f358f85d2d',
    ProjectAPIKey: 'c05d893e-8ef2-4a17-8dd5-f1b483d4c6f5',
  },
};
